export default "__VITE_ASSET__42707df3__"